import $ from 'jquery'

import { setAccessibleErrorText, unsetAccessibleErrorText } from '../../utils/a11y/forms'
import Recaptcha from '../../utils/recaptcha'
import ScrollHelper from '../../utils/scroll-helper'
import { CLEVERREACH_SITE_KEY } from '../../constants/recaptcha'

const TOGGLE_ACTIVE_VALUE = 'Ja'
const TOGGLE_INACTIVE_VALUE = 'Nein'
const MAGAZINE_ACTIVE_CLASS = 'registration-form__magazine--active'
const INVALID_CLASS = 'is-invalid'
const BTN_DISABLED_CLASS = 'btn--outline'
const EXTENDED_FORM_CLASS = 'registration-form--extended'

const escapeName = name => {
  return name.replace(/([ #;?%&,.+*~':"!^$[\]()=>|/@])/g, '\\$1')
}

class RegistrationForm {
  constructor(selector = '.registration-form') {
    this.$form = $('form', selector)
    this.form = this.$form.get(0)
    this.isExtendedForm = $(selector).hasClass(EXTENDED_FORM_CLASS)

    // Exit if no registration form is present
    if (!this.form) {
      return
    }

    this.inputs = $('input', this.form)
    this.textInputs = $('.form-control', this.form)
    this.checkboxInputs = $('.form-check-input', this.form)
    this.toggleInputs = $('.toggle-wrapper', this.form)

    this.toggleFeedback = $('.toggles-feedback', this.form)
    this.magazineTriggers = $('#magazin-yes, #magazin-no', selector)
    this.magazineAddress = $('.registration-form__magazine', selector)

    this.recaptchaContainer = $('.g-recaptcha', this.form).get(0)
    this.submitButton = $('.form-action .btn', this.form)

    this.recaptchaValid = false

    this.init()
  }

  init() {
    this.initRecaptcha()
    this.listen()

    if (!this.isExtendedForm) {
      return
    }

    // listen to extended forms fields
    this.listenExtended()
  }

  listen() {
    // listen to form submits
    this.$form.on('submit', event => {
      this.submit(event)
    })

    // validate on focus out events
    this.textInputs.on('blur', event => {
      this.showInputsValidationStatus(event.target)
    })

    // validate on click events
    this.checkboxInputs.on('click', event => {
      const checkbox = $(event.target)
      const checkboxGroup = $('input[name=' + escapeName(checkbox.attr('name')) + ']')

      this.showInputsValidationStatus(checkboxGroup)
    })

    // make submit button be aware of all inputs
    this.inputs.on('input', () => {
      this.setSubmitButtonState()
    })
  }

  listenExtended() {
    // listen to magazine triggers
    this.magazineTriggers.on('input', () => {
      const value = this.getToggleValue(this.magazineTriggers)
      value === TOGGLE_ACTIVE_VALUE
        ? this.activateMagazineAddress()
        : this.deactivateMagazineAddress()
    })

    // validate toggles on change
    this.toggleInputs.on('input', () => {
      this.showTogglesValidationStatus()
    })
  }

  submit(event) {
    event.preventDefault()
    const valid = this.validateForm()

    if (valid) {
      return this.form.submit()
    }

    const inputs = this.textInputs.add(this.checkboxInputs)
    this.showInputsValidationStatus(inputs)
    this.showTogglesValidationStatus()
    this.scrollToFirstInvalidInput()
  }

  scrollToFirstInvalidInput() {
    const el = $('.is-invalid', this.form).first()
    ScrollHelper.scrollToElement(el)
      .promise()
      .then(() => el.trigger('focus'))
  }

  activateMagazineAddress() {
    this.magazineAddress.slideDown('fast')
    this.magazineAddress.addClass(MAGAZINE_ACTIVE_CLASS)
    this.setMagazineAddressRequiredState(true)
  }

  deactivateMagazineAddress() {
    this.magazineAddress.slideUp('fast')
    this.magazineAddress.removeClass(MAGAZINE_ACTIVE_CLASS)
    this.setMagazineAddressRequiredState(false)
  }

  setMagazineAddressRequiredState(required) {
    const requiredInputs = $('input[data-required]', this.magazineAddress)

    if (required) {
      requiredInputs.attr('required', true)
      return
    }

    return requiredInputs.attr('required', false)
  }

  getToggleValue(inputs) {
    let value = TOGGLE_INACTIVE_VALUE
    inputs.each((index, trigger) => {
      if ($(trigger).is(':checked') && $(trigger).attr('value') === TOGGLE_ACTIVE_VALUE) {
        value = TOGGLE_ACTIVE_VALUE
      }
    })
    return value
  }

  getTogglesValidationStatus() {
    //! since toggles are not required anymore we just return true
    return true
    // return this.toggleInputs.toArray().some(toggle => {
    //   const inputs = $('input', toggle)
    //   return this.getToggleValue(inputs) === TOGGLE_ACTIVE_VALUE
    // })
  }

  showTogglesValidationStatus() {
    !this.getTogglesValidationStatus()
      ? this.toggleFeedback.addClass(INVALID_CLASS)
      : this.toggleFeedback.removeClass(INVALID_CLASS)
  }

  getRequiredInputsValidationStatus() {
    const requiredInputs = $('input[required]', this.form).toArray()

    return requiredInputs.every(input => {
      return input.validity.valid
    })
  }

  showInputsValidationStatus(inputs) {
    // wrap the inputs as jquery object to handle single & array values
    $(inputs)
      .toArray()
      .forEach(input => {
        if (!input.validity.valid) {
          $(input).addClass(INVALID_CLASS)
          setAccessibleErrorText(input)
        } else {
          $(input).removeClass(INVALID_CLASS)
          unsetAccessibleErrorText(input)
        }
      })
  }

  validateForm() {
    return (
      this.getRequiredInputsValidationStatus() &&
      (this.isExtendedForm ? this.getTogglesValidationStatus() : true) &&
      this.recaptchaValid
    )
  }

  setSubmitButtonState() {
    !this.validateForm()
      ? this.submitButton.addClass(BTN_DISABLED_CLASS)
      : this.submitButton.removeClass(BTN_DISABLED_CLASS)
  }

  initRecaptcha() {
    Recaptcha.render(
      this.recaptchaContainer,
      CLEVERREACH_SITE_KEY,
      this.recaptchaSuccess.bind(this),
      this.recaptchaExpired.bind(this)
    )
  }

  recaptchaSuccess() {
    this.recaptchaValid = true
    this.setSubmitButtonState()
  }

  recaptchaExpired() {
    this.recaptchaValid = false
    this.setSubmitButtonState()
  }
}

export default RegistrationForm
